import "./Header.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Navbutton from "../navbutton/Navbutton"; // Se você estiver usando um botão de menu
import SiYourtraveldottv from "../image/SiYourtraveldottv.png";


const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

const handleNavigation = (sectionId) => {
  if (location.pathname !== "/") {
    navigate("/"); // Volta para a página principal
  }

  setTimeout(() => {
    const section = document.querySelector(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  }, 300); // Pequeno delay para garantir que o DOM carregue
};

  return (
    <header className="head">
      <a href="/" className="logo">
      <img
                    src={SiYourtraveldottv}
                    alt="Logo Hugão"
                    style={{ height: "70px", width: "auto" }}
                  />
      </a>
      <nav className="navbar">
        <button onClick={() => handleNavigation("#home")}>Início</button>
        <button onClick={() => handleNavigation("#about")}>Sobre</button>
        <button onClick={() => handleNavigation("#services")}>Serviços</button>
        <button onClick={() => handleNavigation("#doctors")}>Equipe</button>
        <button onClick={() => handleNavigation("#reviews")}>Clientes</button>
        <button onClick={() => handleNavigation("#blogs")}>Blog</button>
        <button onClick={() => handleNavigation("#book")}>Contato</button>
      </nav>
      <div id="menu-btn">
        <Navbutton />
      </div>
    </header>
  );
};

export default Header;
